/* eslint-disable no-console */
import { SENTRY_DSN } from 'shared/config'

export const setupSentry = () =>
  import('@sentry/browser')
    .then((Sentry) => {
      const DSN = import.meta.env.PROD
        ? SENTRY_DSN
        : 'https://4384c070986b413cabb7fad26f5af3e0@gt.jetru.by/42'

      Sentry.init({ dsn: DSN })
      console.log('[Sentry]: success')
    })
    .catch((error) => console.error(`[Sentry]: `, error))
